export { LOCATION_SELECT_FIELD_TEMPLATE } from './src/app/locations/forms/location/location-select-field-template';
export { LOCATION_SELECT_FIELD_PLACEHOLDER_TEMPLATE } from './src/app/locations/forms/location/location-select-field-placeholder-template';

export { ADDRESS_SELECT_FIELD_TEMPLATE} from './src/app/addresses/forms/address/address-select-field-template';
export { ADDRESS_SELECT_FIELD_PLACEHOLDER_TEMPLATE} from './src/app/addresses/forms/address/addres-select-field-placeholder-template';

export { AddressService } from './src/app/addresses/services/address.service';
export { DonnaCoreModule } from './src/app/core.module';
export { AddressRelationPlugin } from './src/app/addresses/plugins/address-relation/address-relation.plugin';
export { TaxSettingsPlugin } from './src/app/tax/plugins/tax-settings/tax-settings.plugin';
export { LocationSettingsPlugin } from './src/app/locations/plugins/location-settings/location-settings.plugin';
export { AddressModel } from './src/app/addresses/models/address.model';
export { AddressableInterface } from './src/app/addresses/interfaces/addressable.interface';
export { TaxModel } from './src/app/tax/models/tax.model';
export { TaxService } from './src/app/tax/services/tax.service';
export { TaxableInterface } from './src/app/tax/interfaces/taxable.interface';
export { LocationableInterface } from './src/app/locations/interfaces/locationable.interface';
export { LocationModel } from './src/app/locations/models/location.model';
export { LocationService } from './src/app/locations/services/location.service';


// WEBPACK FOOTER //
// ./libs/donna-core/index.ts